module.exports = __webpack_public_path__ + "assets/icon-handle-single.0d60a489.svg";